<template>
  <el-footer height="auto">
    <div class="footer container">
      <!-- <div class="top">
        <div class="icon">
          <a target="_blank" href="https://www.facebook.com/pppoker123" class="facebook-img"></a>
          <a target="_blank" href="https://www.instagram.com/pppokerglobal" class="instagram-img"></a>
          <a
            target="_blank"
            href="https://www.youtube.com/channel/UCpklAxJQBUEoFISwCn9o4jg?view_as=subscriber"
            class="youtube-img"
          ></a>
          <a target="_blank" href="https://twitter.com/pppokerofficial" class="twitter-img"></a>
        </div>
        <div class="download">
          <a
            target="_blank"
            id="footfbAndroidDL"
            :href="'http://dl.pppoker.net/apk/pppoker_fb_last_release.apk' + FB_VERSON"
            @click="toBury('officialwebsite_pc_bottom_download_android', 1009, 1, 0, 0, 13)"
            v-ga="$ga.commands.trackName.bind(this, 'officialwebsite_pc_bottom_download_android')"
          >
            <img src="/official/static/img/home/download_08.png" alt />
          </a>
          <a
            target="_blank"
            id="footappstoreDL"
            href="https://itunes.apple.com/us/app/pppoker-home-games-play-poker/id1101622978?l=zh&ls=1&mt=8"
            @click="toBury('officialwebsite_pc_bottom_homepage_download_appstore', 1009, 1, 0, 0, 14)"
            v-ga="$ga.commands.trackName.bind(this, 'officialwebsite_pc_bottom_homepage_download_appstore')"
          >
            <img src="/official/static/img/home/download_06.png" alt />
          </a>
          <a
            target="_blank"
            id="footgoogleplayDl"
            href="https://play.google.com/store/apps/details?id=com.lein.pppoker.android"
            @click="toBury('officialwebsite_pc_bottom_homepage_download_googleplay', 1009, 1, 0, 0, 15)"
            v-ga="$ga.commands.trackName.bind(this, 'officialwebsite_pc_bottom_homepage_download_googleplay')"
          >
            <img src="/official/static/img/home/download_05.png" alt />
          </a>
          <a
            target="_blank"
            id="footwindowsDL"
            :href="'http://dl.pppoker.net/win/pppoker_pc_last_release.msi' + PC_VERSON"
            @click="toBury('officialwebsite_pc_bottom_homepage_download_windows', 1009, 1, 0, 0, 16)"
            v-ga="$ga.commands.trackName.bind(this, 'officialwebsite_pc_bottom_homepage_download_windows')"
          >
            <img src="/official/static/img/home/download_07.png" alt />
          </a>
        </div>
      </div> -->
      <div class="middle">
        <div class="middle_url">
          <!-- <a target="_blank" href="#/about">{{ $t('common.p24') }}</a> -->
          <p>{{ $t('ppwcHome.p7') }}</p>
          <a place="link" href="mailto:events@pppoker.net">events@pppoker.net</a>
        </div>
        <div class="middle_url">
          <!-- <a target="_blank" href="#/brand">{{ $t('common.p25') }}</a>
          <br /> -->
          <p>{{ $t('ppwcHome.p9') }}</p>
          <a target="_blank" href="#/user-agreement-ppwc">{{ $t('ppwcHome.p10') }}</a>
          <br />
          <a target="_blank" href="#/privacy-policy-ppwc">{{ $t('ppwcHome.p11') }}</a>
          <!-- <br /> -->
          <!-- <a target="_blank" href="#/legal-affairs/Community">{{ $t('ppwcHome.p12') }}</a> -->
        </div>
        <!-- <div class="middle_url">
          <a target="_blank" href="#/legal-affairs/Privacy">{{ $t('common.p26') }}</a>
          <br />
          <a target="_blank" href="#/legal-affairs/Unsolicited">{{ $t('common.p29') }}</a>
        </div> -->
        <div class="submit">
          <!-- <el-input v-model.trim="input" :placeholder="$t('common.p22')"></el-input>
          <el-button @click="sumit">{{ $t('common.p23') }}</el-button> -->
          <img class="logo" src="/official/static/img/ppwc/logo_01.png" />
        </div>
      </div>

      <el-divider></el-divider>

      <div class="copyright">
        <p>{{ $t('ppwcHome.p13') }}</p>

      </div>
    </div>

    <div class="pops" v-if="show">
      <div class="dark"></div>
      <div class="pop">
        <div class="f-dialog">
          <div class="f-title">
            <div class="f-t-title">
              <p>{{ $t('common.p31') }}</p>
            </div>
          </div>
          <div class="f-content">
            <p>{{ $t('common.p32') }}</p>
            <p style="margin-bottom: 18px;">{{ $t('common.p33') }}</p>
            <p style="font-size:20px;">{{ $t('common.p34') }}</p>
            <p style="font-size:20px;">{{ $t('common.p35') }}</p>
          </div>
          <div class="f-t-close" @click="closeDialog">
            <p>{{ $t('common.p39') }}</p>
          </div>
        </div>
      </div>
    </div>
  </el-footer>
</template>

<script>
// @ is an alias to /src
import { receiveUserEmail } from '@/api/official'

export default {
  data () {
    return {
      input: '',
      show: false,
      PC_VERSON: '',
      FB_VERSON: ''
    }
  },
  methods: {
    closeDialog () {
      this.show = false
      this.input = ''
    },
    sumit () {
      var email = this.input
      var reg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/
      if (!reg.test(email)) {
        alert('Please input a valid email')
      } else {
        var t = Date.parse(new Date())
        var sign = hex_md5(email + '|' + t)

        receiveUserEmail({
          email,
          time: t,
          sign
        })
          .then(res => {
            this.show = true
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    toBury (key, f1, f2, f3, f4, f5) {
      this.$axios.get(
        'https://client-click.cn-hongkong.log.aliyuncs.com/logstores/client-logstroe/track',
        {
          params: {
            APIVersion: '0.6.0',
            __topic__: key,
            f1,
            f2,
            f3,
            f4,
            f5,
            log_type: 10001
          }
        }
      )
    }
  },
  created () {
    // this.PC_VERSON = PC_VERSON
    // this.FB_VERSON = FB_VERSON
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.el-footer {
  position: relative;
  font-size: 14px;
  color: #fff;
  // background: url("/official/static/img/home/bg_03.png") center top;
  // background-repeat: no-repeat;
  background-color: #000;
  // margin-top: -74px;
  a {
    box-shadow: 0 1PX;
  }
  .footer {
    position: relative;
    // height: 300px;
    padding: 100px 10px;
    .top {
      position: relative;
      padding-top: 95px;
      .icon {
        display: inline-block;
        margin-top: 20px;
        a {
          margin: 0 10px;
          display: inline-block;
          background-size: 100%;
          background-repeat: no-repeat;
          background-position: center center;
          width: 16px;
          height: 32px;
        }
        .facebook-img {
          background-image: url(/official/static/img/home/2_facebook_w.png);
          &:hover {
            background-image: url(/official/static/img/home/2_facebook_g.png);
          }
        }
        .instagram-img {
          width: 24px;
          background-image: url(/official/static/img/home/2_ins_w.png);
          &:hover {
            background-image: url(/official/static/img/home/2_ins_g.png);
          }
        }
        .youtube-img {
          width: 26px;
          background-image: url(/official/static/img/home/2_youtube_w.png);
          &:hover {
            background-image: url(/official/static/img/home/2_youtube_g.png);
          }
        }
        .twitter-img {
          width: 24px;
          background-image: url(/official/static/img/home/2_twitter_w.png);
          &:hover {
            background-image: url(/official/static/img/home/2_twitter_g.png);
          }
        }
      }
      .download {
        float: right;
        a {
          margin: 0 10px;
        }
      }
    }
    .el-divider--horizontal {
      margin: 30px 0px;
      background-color: #252525;
      // opacity: 0.37;
    }
    .middle {
      position: relative;
      .middle_url {
        display: inline-block;
        vertical-align: top;
        margin-right: 70px;
        a {
          font-size: 14px;
          margin: 8px 0px;
          display: inline-block;
          &:hover {
            color: #077594;
          }
        }
        p {
          font-size: 18px;
          margin: 8px 0px;
        }
      }
      .submit {
        position: absolute;
        display: inline-block;
        top: 15px;
        right: 10px;
        .el-input {
          width: 280px;
          // margin-right: 3px;
          vertical-align: middle;
          /deep/.el-input__inner {
            color: #797979;
            background-image: url(/official/static/img/home/submit_bg_01.jpg);
            background-repeat: repeat;
            border: none;
            border-radius: 0px;
          }
        }
        .el-button {
          vertical-align: middle;
          border-radius: 0px;
          color: #383838;
          background-image: url(/official/static/img/home/submit_bg_02.jpg);
          background-repeat: repeat;
          font-size: 16px;
          height: 40px;
          padding: 12px 14px;
          border: none;
          // &:active {
          // }
        }
      }
    }
    .copyright {
      position: relative;
      // padding-top: 110px;
      p {
        display: inline-block;
        color: #898989;
        font-size: 12px;
      }
      .logo {
        float: right;
      }
    }
  }

  .pops {
    position: fixed;
    top: 20%;
    left: 50%;
    width: 660px;
    margin-left: -330px;
    z-index: 3000;
    .dark {
      background-color: #000000;
      filter: Alpha(opacity=60);
      -moz-opacity: 0.6;
      opacity: 0.6;
      width: 100%;
      height: 100%;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 9;
    }
    .f-dialog {
      width: 100%;
      height: auto;
      z-index: 3500;
      position: relative;
      background-color: #fff;
      padding-bottom: 40px;
      border-radius: 4px;
      .f-t-close {
        position: relative;
        height: 46px;
        width: 238px;
        // top: 0px;
        // right: 0px;
        // background-image: url("/official/static/img/dialog/button.png");
        // background-repeat: no-repeat;
        // background-size: contain;
        background-color: #077594;
        border-radius: 4px;
        margin: 26px auto 0px auto;
        cursor: pointer;
        p {
          color: #fff;
          line-height: 46px;
          font-size: 26px;
          text-align: center;
        }
      }
      .f-title {
        width: 100%;
        height: 120px;
        position: relative;
        .f-t-title {
          height: 140px;
          width: 100%;
          display: inline-block;
          // background-image: url("/official/static/img/dialog/title.jpg");
          // background-repeat: no-repeat;
          // background-size: 100% 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          p {
            font-size: 60px;
            color: #077594;
            font-weight: bold;
          }
        }
      }
      .f-content {
        width: 100%;
        // height: 287px;
        // background-image: url("/official/static/img/dialog/bg.jpg");
        // background-repeat: repeat;
        // display: flex;
        // flex-direction: column;
        // justify-content: center;
        // align-items: flex-start;
        p {
          padding: 0 30px;
          // text-align: center;
          font-size: 24px;
          line-height: 32px;
          color: #616161;
        }
      }
    }
  }
}
</style>
